import React from 'react';
import { getDisplayName } from '../components/index.mjs';
import { ErrorLoggerContext } from './context.mjs';

function withError() {
  return function addError(WrappedComponent) {
    var _class;
    return _class = class WithError extends React.Component {
      render() {
        return /*#__PURE__*/React.createElement(ErrorLoggerContext.Consumer, null, errorLogger => /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
          errorLogger: errorLogger
        }, this.props)));
      }
    }, _class.displayName = `withError(${getDisplayName(WrappedComponent)})`, _class.WrappedComponent = WrappedComponent, _class;
  };
}

export { withError };
